function wu_module_iama() {

	$('button[data-choice]').on('click', function(e) {
		//get var
		var wu_choice = $(this).data('choice');

		//show buttons
		$('.mod--ima__choices__results > *').hide();
		$('.mod--ima__choices__results > *[data-choice="'+wu_choice+'"]').show();

		//set cookie
		$.cookie('WU_Profile', wu_choice, { expires: 7 });

	});
}

wu_module_iama();